import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog,MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { LogisticaService } from '../services/logistica.service';
import { showSpinner, hideSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { DialogComboCreationComponent } from '../dialog-combo-creation/dialog-combo-creation.component';
import { ModalHistoricoAlertasComponent } from '../modal-historico-alertas/modal-historico-alertas.component';

@Component({
  selector: 'app-modal-alertas',
  templateUrl: './modal-alertas.component.html',
  styleUrls: ['./modal-alertas.component.scss']
})
export class ModalAlertasComponent implements OnInit {
  alertas: any[] = [];
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['ID_ALERT', 'PORC_AVANCE', 'ASUNTO', 'DESTINATARIOS', 'ESTADO','USUARIO_CREACION', 'USUARIO_MODIFICACION', 'ACCIONES'];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  static switch: any = 0;

  constructor(
    public dialogRef: MatDialogRef<ModalAlertasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private logisticaService: LogisticaService,
    private notificationService: NotificationHelper,
    private dialog: MatDialog
  ) {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  async ngOnInit() {
    await this.cargarAlertas();
  }

  static async changeValueDialog(value: any) {
    this.switch = value;
  }

  async cargarAlertas() {
    try {
      showSpinner();
      console.log('Cargando alertas para ID_REG_CAPAC:', this.data);
      const response = await this.logisticaService.obtenerAlertas(this.data.ID_REG || this.data.ID_REG_CAL);
      
      if (response && response.success) {
        this.alertas = response.data || [];
        this.dataSource = new MatTableDataSource<any>(this.alertas);
        this.dataSource.paginator = this.paginator;
      } else {
        this.notificationService.infoMessage("No hay alertas para esta capacidad");
      }
    } catch (error) {
      console.error('Error al cargar alertas:', error);
      this.notificationService.errorMessage("Error al cargar las alertas");
    } finally {
      hideSpinner();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('es-CO', {
      day: '2-digit',
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatDestinatarios(destinatarios: string): string {
    if (!destinatarios) return '';
    return destinatarios.split(';').join('<br>');
  }

  async openDialog(action, data) {
      const dialogConfig = new MatDialogConfig();
      data.action = action;
      dialogConfig.data = data;
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.width = '100%';
      dialogConfig.height = 'fit-content';
      const dialogRef = this.dialog.open(
        DialogComboCreationComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe(async (result) => {
        if (ModalAlertasComponent.switch == 1) {
          await this.ngOnInit();
        }
        ModalAlertasComponent.switch = 0;
      });
      /* dialogRef.afterClosed().subscribe(async (result) => {
        console.log(result?.success,result.refresh,this.selectedRow);
        if (result?.success && result.refresh) {
          this.ngOnInit()
          if(this.selectedRow){
            this.selectRow(this.selectedRow.tipo)
          }else if (['departamento', 'municipio', 'zona'].includes(result.id_poli)) {
            await this.recargarGeografia(this.selectedRow.id_poli);
          } else if (result.tipo === 'new_capa') {
            await this.recargarCapacidades(this.selectedRow.id_poli);
          }
        }
      }); */
    }

  abrirModalHistoricoAlertas() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { idCapacidad: this.data.ID_REG || this.data.ID_REG_CAL };
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '1400px';
    
    this.dialog.open(ModalHistoricoAlertasComponent, dialogConfig);
  }
}